import React from 'react';

interface GithubSettingsSkeletonProps {
  step?: number;
}

const GithubSettingsSkeleton: React.FC<GithubSettingsSkeletonProps> = ({ step = 1 }) => {
  if (step === 1) {
    return (
      <div className="p-4 md:px-8 md:py-4 flex-1 overflow-y-auto">
        <div className="space-y-6 max-w-3xl">
          {/* Main Info Card Skeleton */}
          <div className="rounded-xl border border-gray-200 dark:border-gray-700 p-6 bg-white dark:bg-gray-800 shadow-sm">
            <div className="flex items-start gap-4 mb-6">
              <div className="flex-shrink-0 mt-2">
                <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse"></div>
              </div>
              <div className="flex-1 space-y-2">
                <div className="h-6 bg-gray-300 dark:bg-gray-600 rounded w-64 animate-pulse"></div>
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full animate-pulse"></div>
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 animate-pulse"></div>
              </div>
            </div>

            {/* Features List Skeleton */}
            <div className="mb-6 pl-1 space-y-4">
              <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-32 animate-pulse mb-3"></div>
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse flex-shrink-0 mt-0.5"></div>
                  <div className="space-y-1.5 flex-1">
                    <div className="h-3.5 bg-gray-300 dark:bg-gray-600 rounded w-40 animate-pulse"></div>
                    <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-64 animate-pulse"></div>
                  </div>
                </div>
              ))}
            </div>



            {/* Input Section Skeleton */}
            <div className="mt-6 space-y-4 border-t border-gray-100 dark:border-gray-700 pt-6">
              <div className="space-y-2">
                <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-40 animate-pulse"></div>
                <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg w-full animate-pulse"></div>
              </div>
            </div>




          </div>

          {/* Info Box Skeleton */}
          <div className="mt-6 p-4 rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 bg-blue-200 dark:bg-blue-800 rounded-full animate-pulse flex-shrink-0 mt-0.5"></div>
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-blue-200 dark:bg-blue-800 rounded w-48 animate-pulse"></div>
                <div className="h-3 bg-blue-100 dark:bg-blue-900 rounded w-full animate-pulse"></div>
                <div className="h-3 bg-blue-100 dark:bg-blue-900 rounded w-3/4 animate-pulse"></div>
                <div className="h-3 bg-blue-200 dark:bg-blue-800 rounded w-32 animate-pulse mt-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Step 2 skeleton
  return (
    <div className="p-4 md:px-8 md:py-4 flex-1 overflow-y-auto">
      <div className="space-y-5">
        {/* Connection Status Skeleton */}
        <div className="flex items-center justify-between px-3 py-2 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-xl">
          <div className="flex items-center gap-3">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <div className="h-4 bg-green-200 dark:bg-green-800 rounded w-48 animate-pulse"></div>
          </div>
          <div className="h-7 w-20 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
        </div>

        {/* Settings Skeleton */}
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4 shadow-sm">
          <div className="h-5 bg-gray-300 dark:bg-gray-600 rounded-md w-40 mb-3 animate-pulse"></div>
          <div className="space-y-4">
            {/* PAT Input Skeleton */}
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-32 animate-pulse"></div>
              <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg w-full animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Next Steps Skeleton */}
        <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800 p-5">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-5 h-5 bg-blue-200 dark:bg-blue-800 rounded-full animate-pulse"></div>
            <div className="h-5 bg-blue-200 dark:bg-blue-800 rounded w-48 animate-pulse"></div>
          </div>
          <div className="grid gap-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white dark:bg-gray-800 p-3 rounded-lg border border-blue-100 dark:border-blue-800/50">
                <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-40 mb-2 animate-pulse"></div>
                <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GithubSettingsSkeleton;